import { isValidElement, type FC } from 'react';
import { cx } from '@linaria/atomic';
import { Icon, type IconName } from '@frontend/icons';
import { Chip } from '@frontend/design-system';
import { styles } from '../panel-feature-promotion-banner.styles';
import type {
  PanelFeaturePromotionBannerFeatureChipProps,
  PanelFeaturePromotionBannerFeatureChipsProps,
} from '../panel-feature-promotion-banner.types';

export const PanelFeaturePromotionBannerFeatureChips: FC<PanelFeaturePromotionBannerFeatureChipsProps> = ({
  children,
  showInGrid = false,
  className,
  testId,
}) => {
  return (
    <div className={cx(showInGrid ? styles.featureChipsGrid : styles.featureChips, className)} data-testid={testId}>
      {children}
    </div>
  );
};

export const PanelFeaturePromotionBannerFeatureChip: FC<PanelFeaturePromotionBannerFeatureChipProps> = ({
  children,
  icon = 'check-small',
  className,
  testId,
}) => {
  const iconContent =
    typeof icon === 'string' ? <Icon name={icon as IconName} size={16} /> : isValidElement(icon) ? icon : null;

  return (
    <Chip
      variant='seaweed'
      className={cx(styles.featureChip, className)}
      maxWidth='100%'
      data-testid={testId}
      leftElement={iconContent ? <span className={styles.featureChipIcon}>{iconContent}</span> : undefined}
    >
      {children}
    </Chip>
  );
};
